import React, {
    useState
} from "react";
import axios from "axios";
import "./Dictionary.css";
import Results from "./Results";
import Photos from "./Photos";

export default function Dictionary() {
    let [keyword, setKeyword] = useState("");
    let [results, setResults] = useState(null);
    let [photos, setPhotos] = useState([]);
    let [loaded, setLoaded] = useState(false);

    function handleResponse(response) {
        setResults(response.data[0]);
        let pexelsApiKey =
            "563492ad6f91700001000001e7b2800bac8748beaa49fa56b3566ecb";
        let pexelsApiUrl = `https://api.pexels.com/v1/search?query=${keyword}&per_page=9`;

        let headers = {
            Authorization: ` Bearer ${pexelsApiKey}`
        };
        axios.get(pexelsApiUrl, {
            headers: headers
        }).then(handlePexelsResponse);
    }

    function handlePexelsResponse(response) {
        setPhotos(response.data.photos);
    }

    function load() {
        setLoaded(true);
        search();
    }

    function search() {
        let apiUrl = `https://api.dictionaryapi.dev/api/v2/entries/en/${keyword}`;
        axios.get(apiUrl).then(handleResponse);
    }

    function handleSubmit(event) {
        event.preventDefault();
        search();
    }

    function handleKeywordChange(event) {
        setKeyword(event.target.value);
    }

    if (loaded) {
        return ( <div className = "Dictionary" >
            <form onSubmit = {
                handleSubmit
            } >
            <h1 > What word do you want to look up ? </h1> 
            <input
            type = "search"
            autoFocus = {
                true
            }
            className = "form-control search-input"
            onChange = {
                handleKeywordChange
            }
            /> </form>

            <Results results = {
                results
            }
            /> <Photos photos = {
                photos
            }
            /> </div>
        );
    } else {
        load();
        return "Loading!";
    }
}